// Journalisation de mise au point, silencieuse en production.
//
// Le dépôt compte des centaines de `console.log` de diagnostic, dont 81 dans
// le store de contexte et 48 dans App.vue, c'est-à-dire en plein chemin de
// démarrage. En production ils ne servent à RIEN : le filtre `beforeBreadcrumb`
// de Sentry (main.ts) ne conserve déjà que `warning` et `error`, donc aucun de
// ces messages ne remonte. Il ne reste que leur coût, payé à chaque lancement.
//
// `debugLog` remplace ces appels-là, et EUX SEULEMENT. `console.warn` et
// `console.error` gardent leur place : ils remontent à Sentry et disent quelque
// chose quand l'application va mal.
//
// Note : les arguments sont évalués avant l'appel, comme avec `console.log`.
// Pour un calcul coûteux réservé au diagnostic, garder le site sous `isDebug`.

export const isDebug = import.meta.env.DEV

export function debugLog(...args: unknown[]): void {
  if (!isDebug) return
  console.log(...args)
}
